import { render, staticRenderFns } from "./EditFert.vue?vue&type=template&id=7c390b28&"
import script from "./EditFert.vue?vue&type=script&lang=js&"
export * from "./EditFert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports